import React from 'react';
import { useAppSelector } from '../../../state/hooks';
import { DiaryStudyExpertsStyles } from './styles';
import getTranslationsByLangOrEng from '../../../utils/getTranslationsByLangOrLang';
import ButtonWithArrowOnHover from '../../buttonWithArrowOnHover/ButtonWithArrowOnHover';
import provide from '../../../assets/images/diaryStudy/provide.svg';

export const DiaryStudyExperts = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);
  return (
    <DiaryStudyExpertsStyles>
      <div className="container">
        <h5>
          {getTranslationsByLangOrEng(interfaceLanguage, 'diary_study_19')}
        </h5>
        <div className="content">
          <h1>
            {getTranslationsByLangOrEng(interfaceLanguage, 'diary_study_20')}
          </h1>
        </div>
      </div>
      <div className="container">
        <div className="cards">
          <div className="cards-item">
            <img src={provide} alt="Diary Study Experts" />
            <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'diary_study_21')}</h6>
            <p>{getTranslationsByLangOrEng(interfaceLanguage, 'diary_study_22')}</p>
          </div>
          <div className="cards-item">
            <img src={provide} alt="Diary Study Experts" />
            <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'diary_study_23')}</h6>
            <p>{getTranslationsByLangOrEng(interfaceLanguage, 'diary_study_24')}</p>
          </div>
          <div className="cards-item">
            <img src={provide} alt="Diary Study Experts" />
            <h6>{getTranslationsByLangOrEng(interfaceLanguage, 'diary_study_25')}</h6>
            <p>{getTranslationsByLangOrEng(interfaceLanguage, 'diary_study_26')}</p>
          </div>
        </div>
      </div>

      <div className="btn-container">
        <ButtonWithArrowOnHover
          onClick={() => {
            const elem = document.getElementById('form');
            elem!.scrollIntoView({ block: 'start', behavior: 'smooth' });
          }}
          arrowColor="#fff"
          textColor="#000"
          borderColor="#000"
          borderOnHover="#000"
          background="transparent"
          className="btn"
          hoverBackground="#000"
          hoverTextColor="#fff"
          text={getTranslationsByLangOrEng(
            interfaceLanguage,
            'diary_study_5',
          )}
        />
      </div>
    </DiaryStudyExpertsStyles>
  );
};
